import styled from "styled-components";

export const ButtonShowError = styled.div`
  font-size: 0.75rem;
  margin-right: 5px;
`;
